import anime from "animejs";

function reOrderActiveFlashmessages(){
    const spacing = 10;
    for (const msg of document.querySelectorAll(".flashMessage.is-active")) {
        const oldOffset = parseInt(msg.dataset.offsetTop);
        const newOffsetTop = oldOffset + msg.getBoundingClientRect().height + spacing;
        msg.dataset.offsetTop = newOffsetTop;

        anime({
            targets: msg,
            translateY: [oldOffset, newOffsetTop],
            translateX: ["-50%", "-50%"],
            duration: 200,
            easing: 'linear'
        });
    }
}

function showFlashmessage(msg, delay = 200) {
    const spacing = 10;

    let offsetY = 0;
    for (const m of document.querySelectorAll(".flashMessage.is-active")) {
        const height = m.getBoundingClientRect().height;
        offsetY += height + spacing;
    }

    offsetY = -1*(offsetY);

    msg.classList.add("is-active");
    msg.dataset.offsetTop = offsetY;

    anime({
        targets: msg,
        translateY: [50, offsetY],
        translateX: ["-50%", "-50%"],
        opacity: 1,
        duration: 200,
        delay: delay,
        easing: 'linear'
    });

    for (const flashmessageClose of msg.querySelectorAll(".flashMessage__close")) {
        flashmessageClose.addEventListener("click", eventCloseFlashMessage);
    }
}

function hideFlashmessage(msg, delay = 200) {
    const offsetTop = parseInt(msg.dataset.offsetTop || "0", 10);

    anime({
        targets: msg,
        translateY: [offsetTop, offsetTop + 50],
        opacity: 0,
        duration: 200,
        delay: delay,
        easing: 'linear',
        complete: () => {
            msg.classList.remove("is-active");
            reOrderActiveFlashmessages();
        }
    });

    for (const closeBtn of msg.querySelectorAll(".flashMessage__close")) {
        closeBtn.removeEventListener("click", eventCloseFlashMessage);
    }
}

function eventCloseFlashMessage(e){
    const msg = e.target.closest(".flashMessage");
    if(msg){
        hideFlashmessage(msg);
    }
}

function generateNewFlashmessage(templateID = "flashMessageTemplate") {
    const template = document.getElementById(templateID);
    if (template) {
        const flashWrapper = document.getElementById('flashMessages');
        if(flashWrapper){
            return flashWrapper.appendChild(template.content.cloneNode(true).querySelector('.flashMessage'));
        }
    } else {
        console.error("Cannot find Flashmessage Template");
    }
    return false;
}

export function getNewFlashmessage(msg = "", type = 0){
    let iconClass = "icon icon-exclamation";
    let flashClass = "flashMessage--info";
    switch (type){
        case 1:
            iconClass = "icon icon-check";
            flashClass = "flashMessage--success";
            break;
        case 2:
            flashClass = "flashMessage--warning";
            break;
        case 3:
            flashClass = "flashMessage--error";
            break;
    }
    const flashMessage = generateNewFlashmessage();
    if (flashMessage) {
        const flashIcon = flashMessage.querySelector(".flashMessage__icon i");
        const flashMsg = flashMessage.querySelector(".flashMessage__msg");
        if(flashIcon){
            flashIcon.setAttribute("class",iconClass);
        }
        if(flashMsg){
            flashMsg.innerText = msg;
        }
        flashMessage.classList.add(flashClass);
        showFlashmessage(flashMessage);
        let delayHideFlashMessages = 6000;
        if (typeof GLOBALS!== "undefined") {
            delayHideFlashMessages = GLOBALS.delayHideFlashMessages;
        }

        setTimeout(function (){
            hideFlashmessage(flashMessage);
        },delayHideFlashMessages);
    }
}

export function initFlashmessages(wrapper = document.getElementById('flashMessages')){
    if(wrapper){
        const messages = wrapper.querySelectorAll(".flashMessage");
        let delayShowFlashMessages = 200;
        if (typeof GLOBALS!== "undefined") {
            delayShowFlashMessages = GLOBALS.delayShowFlashMessages;
        }
        if(messages){
            setTimeout(function (){
                let count = 1;
                for(const msg of messages){
                    if(!msg.classList.contains("is-active")){
                        showFlashmessage(msg,200 * count);
                        count++;
                    }
                }
            },delayShowFlashMessages);
        }
    }
}